import { render } from "./Accessi.vue?vue&type=template&id=0a5f1426&scoped=true"
import script from "./Accessi.vue?vue&type=script&lang=js"
export * from "./Accessi.vue?vue&type=script&lang=js"

import "./Accessi.vue?vue&type=style&index=0&id=0a5f1426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5f1426"]])

export default __exports__